import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
//imgaes
import RouteSpotlightImg1 from '../../assets/img/route-104-spotlight-img1.jpg';
import RouteSpotlightImg2 from '../../assets/img/route-104-spotlight-img2.jpg';
import RouteSpotlightImg3 from '../../assets/img/route-104-spotlight-img3.jpg';

const RouteSpotlight = ({language}) => {
    return (
        <section className="route-spotlight mb-5">
            <Container>
                <h2 className='mb-5'>{language === "Chinese" ? "路線特色亮點" : "Route Highlights"}</h2>
                <Row className='align-items-center'>
                    <Col md={4}>
                        <h3>玄光寺</h3>
                        <h3><em>Xuanguang Temple</em></h3>
                        <p>{language === "Chinese" ? "玄光寺，坐落於日月潭畔，以其靜謐的禪意與壯麗的湖光山色聞名。寺前的玄奘大師銅像俯瞰湖面，風景如畫，是騎行途中放鬆心靈的絕佳景點。" : "Set on the shore of Sun Moon Lake, Xuanguang Temple is known for its tranquil Zen atmosphere and magnificent lake and mountain views. The bronze statue of Master Xuanzang in front of the temple overlooks the picturesque lake, making it a perfect spot to clear your mind during the ride."}</p>
                        <img src={RouteSpotlightImg1} alt="" />
                    </Col>
                    <Col md={4}>
                        <img src={RouteSpotlightImg2} alt="" />
                        <h3 className='mt-3'>向山遊客中心</h3>
                        <h3><em>Xiangshan Visitor Center</em></h3>
                        <p>{language === "Chinese" ? "向山遊客中心位於日月潭畔，結合現代設計與自然景觀，展現獨特美感。中心內有展示區介紹日月潭的歷史與生態、多媒體互動體驗區。遊客可參觀展覽、享受咖啡館，或在觀景台俯瞰湖光山色。作為環湖自行車道起點則提供了絕佳的騎行體驗，是放鬆身心、探索自然與歷史的理想之地。" : "Located on the shore of Sun Moon Lake, the Xiangshan Visitor Center blends modern architecture with the natural landscape. Inside are exhibitions on the history and ecology of Sun Moon Lake and interactive multimedia zones. Visitors can explore the exhibits, relax at the café, or take in sweeping lake and mountain views from the observation deck. As the starting point of the lakeside bike path, it is also a great place to begin a ride — ideal for unwinding and discovering the area's nature and history."}</p>
                    </Col>
                    <Col md={4}>
                        <h3>伊達邵碼頭</h3>
                        <h3><em>Ita Thao Pier</em></h3>
                        <p>{language === "Chinese" ? "位於日月潭的南岸，是體驗當地風情的絕佳景點。融合了邵族文化，提供豐富的民俗活動和美食選擇。碼頭附近的市集有各種邵族手工藝品和特色小吃，深入了解在地文化。" : "On the south shore of Sun Moon Lake, Ita Thao Pier is a great place to experience local life. Steeped in the culture of the Indigenous Thao people, it offers a wide range of folk activities and food. The market near the pier sells Thao handicrafts and local snacks — a chance to get to know the local culture up close."}</p>
                        <img src={RouteSpotlightImg3} alt="" />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default RouteSpotlight